// JavaScript dependencies

// Style sheets
import './scss/main.scss';

// Custom JavaScript
import {init_header} from './js/header';
import {init_sliders} from './js/slider';

document.addEventListener('DOMContentLoaded', function () {
    init_header();
    init_sliders();
});
